import { useSelector } from 'react-redux'
import props from '../../redux/props'

const useTranslation = () => {
  const t = useSelector((s) => s[props.TRANSLATION])
  return t
}

export default useTranslation
